import React, { useState } from "react";
import uiContext from "./uiContext";

function UiState(props) {
  const [widthSize, setWidthSize] = useState(0);
  // 0 very small mobile
  //1 browser min garda min samma jane
  //2 to fix bigArticleItem
  //3  for large screens

  const [sideBar, setSideBar] = useState(0);
  // 0 for close, 1 for open

  const [dashNav, setDashNav] = useState(1);

  const [dataContext, setDataContext] = useState({
    title: "",
    category: "",
    imglink: "",
    slug: "",
    article: "",
  });

  // blog edit modal
  const [editModal, setEditModal] = useState(false);

  //blog to edit
  const [toEdit,setToEdit]=useState(null);

  return (
    <uiContext.Provider
      value={{
        widthSize,
        setWidthSize,
        sideBar,
        setSideBar,
        dashNav,
        setDashNav,
        dataContext,
        setDataContext,
        setEditModal,
        editModal,
        toEdit,setToEdit
      }}
    >
      {props.children}
    </uiContext.Provider>
  );
}

export default UiState;
